/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_LostInputs */



/**
* | output |
* | --- |
* | "Lost in the Rift" |
*
* @param {Error_Notfound_Heading_LostInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_lost = /** @type {((inputs?: Error_Notfound_Heading_LostInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_LostInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Rift verloren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Perdu dans la Faille")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("迷失在裂隙中")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("迷失在裂隙中")
	if (locale === "ko") return /** @type {LocalizedString} */ ("균열 속에서 길을 잃었습니다")
	return /** @type {LocalizedString} */ ("Lost in the Rift")
});